import { Form, FormTextField, SearchRoundedIcon } from '@shared/components';
import debounce from 'lodash/debounce';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { useExamCourseSearchParams } from '../../hooks';

interface ExaminationCourseSearchFormInput {
  search: string;
}

export default function ExaminationCourseSearchBox() {
  const [{ search }, setExamCourseSearchParams] = useExamCourseSearchParams();

  const formContext = useForm<ExaminationCourseSearchFormInput>({
    defaultValues: {
      search,
    },
  });

  const handleSubmit = (formValues: ExaminationCourseSearchFormInput) => {
    setExamCourseSearchParams({
      search: formValues.search.trim(),
      page: null,
    });
  };

  useEffect(() => {
    const subscription = formContext.watch(debounce((formValues) => handleSubmit(formValues), 700));

    return subscription.unsubscribe;
  }, [formContext.watch, setExamCourseSearchParams]);

  return (
    <FormProvider {...formContext}>
      <Form onSubmit={formContext.handleSubmit(handleSubmit)}>
        <FormTextField
          placeholder='ค้นหาหลักสูตรทดสอบ...'
          name='search'
          slotProps={{
            input: {
              startAdornment: (
                <SearchRoundedIcon sx={{ color: (theme) => theme.palette.grey[500] }} />
              ),
            },
          }}
        />
      </Form>
    </FormProvider>
  );
}
